var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoPassengerinfoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 107,
    viewBox: "0 0 336 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_731_8087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 70.86V22.67C0.0184751 16.6615 2.41421 10.9045 6.66383 6.65677C10.9134 2.40903 16.6715 0.0158252 22.68 0H76.68V48.19C76.6642 54.1976 74.2706 59.9546 70.0226 64.2026C65.7746 68.4507 60.0176 70.8442 54.01 70.86H0Z",
    fill: "#83C06F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.68 8.51001C18.9227 8.51266 15.32 10.0064 12.6632 12.6632C10.0064 15.3201 8.51266 18.9227 8.51001 22.68V62.37H54.04C57.7965 62.3647 61.3976 60.8701 64.0539 58.2139C66.7101 55.5576 68.2047 51.9565 68.21 48.2V8.51001H22.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.86 30.77H34.53C40.38 30.77 42.3 32.21 42.3 38.51C42.3 44.81 40.23 45.98 34.53 45.98H29.05V53.27H24.86V30.77ZM34.53 42.29C37.53 42.23 38.11 41.66 38.11 38.51C38.11 35.36 37.67 34.43 34.53 34.46H29.05V42.29H34.53Z",
    fill: "#83C06F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.23 53.27H48.04V30.77H52.23V53.27Z",
    fill: "#83C06F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 87.01H2.75V106.11H6.13V98.99H17.25C22.83 98.99 23.25 96.51 23.25 92.44C23.27 87.92 21.16 87.01 17.75 87.01ZM6.17 90.01H17.17C19.17 90.01 19.88 90.54 19.88 92.19V93.91C19.88 95.39 19.15 95.99 17.37 95.99H6.17V90.01Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.35 87.01L24.35 106.11H28.2L30.38 102.29H43.87L46.06 106.11H49.9L38.9 87.01H35.35ZM42.15 99.29H32.09L37.09 90.52L42.15 99.29Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.33 94.9101H60.33C56.62 94.9101 56.47 94.1801 56.47 92.5401C56.47 90.2001 57.27 89.8101 62.18 89.8101H64.7C70.7 89.8101 70.7 90.2001 70.77 92.7201V93.2101H74V92.0901C74 88.2401 71.86 86.8101 66.12 86.8101H61C56.08 86.8101 53.22 87.7201 53.22 92.3601C53.22 97.8701 56.51 98.1101 63.36 98.1101H67.87C70.76 98.1101 71.2 98.6401 71.2 100.46C71.2 102.6 70.63 103.31 67.2 103.31H59.82C56.69 103.31 56.44 102.31 56.44 101.19V99.4101H53.21V101.24C53.21 106.31 58.13 106.31 60.21 106.31H66.81C69.64 106.31 74.37 106.31 74.37 101.04V99.8601C74.45 96.4401 72.22 94.9101 67.33 94.9101Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.71 94.9101H86.71C83 94.9101 82.84 94.1801 82.84 92.5401C82.84 90.2001 83.64 89.8101 88.55 89.8101H91.08C97.08 89.8101 97.08 90.2001 97.15 92.7201V93.2101H100.38V92.0901C100.38 88.2401 98.24 86.8101 92.5 86.8101H87.35C82.42 86.8101 79.57 87.7201 79.57 92.3601C79.57 97.8701 82.86 98.1101 89.7 98.1101H94.22C97.11 98.1101 97.55 98.6401 97.55 100.46C97.55 102.6 96.98 103.31 93.55 103.31H86.17C83.04 103.31 82.79 102.31 82.79 101.19V99.4101H79.56V101.24C79.56 106.31 84.48 106.31 86.56 106.31H93.16C95.99 106.31 100.72 106.31 100.72 101.04V99.8601C100.78 96.4401 98.6 94.9101 93.71 94.9101Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.79 97.79H124.08V94.79H109.79V90.02H124.66V87.02H106.41V106.11H124.76V103.11H109.79V97.79Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.29 102.22L133.91 87.02H129.66V106.11H133.03V90.91L148.41 106.11H152.66V87.02H149.29V102.22Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.78 99.1401H177.78V100.51C177.78 102.51 176.78 103.36 174.44 103.36H165.15C162.58 103.36 161.53 102.36 161.53 100.01V93.2101C161.53 90.8301 162.58 89.8601 165.15 89.8601H171.31C177.44 89.8601 177.68 90.2201 177.68 92.9901V93.4901H180.91V92.3401C180.91 88.7101 178.55 86.8601 173.91 86.8601H164.91C160.11 86.8601 158.15 88.9701 158.15 94.1401V99.0901C158.15 104.25 160.15 106.36 164.91 106.36H174.71C179.41 106.36 181.15 104.42 181.15 99.1901V96.1901H168.78V99.1401Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.16 97.79H204.45V94.79H190.16V90.02H205.03V87.02H186.78V106.11H205.13V103.11H190.16V97.79Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.58 87.01H210.03V106.11H213.45V98.96H224.55C226.55 98.96 227.55 99.23 227.55 101.64V106.11H230.78V100.99C230.846 100.321 230.713 99.6473 230.398 99.0533C230.084 98.4592 229.601 97.9711 229.01 97.65C230.09 97.19 231.01 96.22 231.01 94.11V92.64C230.95 88.99 229.93 87.01 224.58 87.01ZM213.41 90.01H223.73C227.22 90.01 227.57 90.64 227.57 92.19V93.84C227.57 95.18 227.04 95.96 224.31 95.96H213.45L213.41 90.01Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.13 87.02H250.75V106.12H254.13V87.02Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.77 102.22L264.39 87.02H260.14V106.11H263.52V90.91L278.9 106.11H283.14V87.02H279.77V102.22Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.09 106.11H292.47V97.79H306.27V94.79H292.47V90.02H306.83V87.02H289.09V106.11Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.29 86.8101H318.18C313.38 86.8101 311.42 88.9201 311.42 94.0901V99.0401C311.42 104.2 313.42 106.31 318.18 106.31H328.29C333.1 106.31 335.05 104.2 335.05 99.0401V94.0901C335.05 88.9201 333.1 86.8101 328.29 86.8101ZM331.68 93.1601V99.9601C331.68 102.34 330.63 103.31 328.05 103.31H318.45C315.88 103.31 314.83 102.31 314.83 99.9601V93.1601C314.83 90.7801 315.83 89.8101 318.45 89.8101H328.08C330.63 89.8101 331.68 90.7801 331.68 93.1601Z",
    fill: "#1D1D1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_731_8087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335.05,
    height: 106.31,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPassengerinfoMobile);
export default __webpack_public_path__ + "static/media/logo_passengerinfo_mobile.6cb6bc899e782bd15b050b4a195a5666.svg";
export { ForwardRef as ReactComponent };